import React, { useState, useEffect } from 'react';
import axios from 'axios';
import api from '../api';
import { useNavigate } from 'react-router-dom';

export default function Prices() {
  const [priceData, setPriceData] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  const refreshAccessToken = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) throw new Error('No refresh token');
      const res = await api.post('/api/auth/refresh-token', { refreshToken });
      localStorage.setItem('authToken', res.data.accessToken);
      return res.data.accessToken;
    } catch (err) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
      navigate('/login_page');
      return null;
    }
  };

  useEffect(() => {
    if (!token) {
      navigate('/login_page');
      return;
    }
    const fetchPrices = async () => {
      try {
        const newToken = token || (await refreshAccessToken());
        if (!newToken) throw new Error('No token');
        const res = await api.get('/api/prices/my-prices', {
          headers: { Authorization: `Bearer ${newToken}` },
        });
        setPriceData(res.data);
      } catch (err) {
        if (err.response?.status === 401) {
          const newToken = await refreshAccessToken();
          if (newToken) {
            const res = await api.get('/api/prices/my-prices', {
              headers: { Authorization: `Bearer ${newToken}` },
            });
            setPriceData(res.data);
          } else {
            setError('جلسه شما منقضی شده است. لطفاً دوباره وارد شوید.');
            setTimeout(() => navigate('/login'), 2000);
          }
        } else {
          setError(err.response?.data?.message || 'خطا در دریافت قیمت‌ها');
        }
      }
    };
    fetchPrices();
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">قیمت‌های خرید و فروش</h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        {priceData ? (
          <div className="bg-white rounded-xl shadow-lg p-6">
            <p className="text-gray-700 mb-4">گرید شما: {priceData.grade}</p>
            <table className="min-w-full border-collapse">
              <thead>
                <tr>
                  <th className="border px-4 py-2">گرید</th>
                  <th className="border px-4 py-2">قیمت خرید (ریال)</th>
                  <th className="border px-4 py-2">قیمت فروش (ریال)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border px-4 py-2">{priceData.grade}</td>
                  <td className="border px-4 py-2">{priceData.buy_price.toLocaleString()}</td>
                  <td className="border px-4 py-2">{priceData.sell_price.toLocaleString()}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-gray-500">در حال بارگذاری...</p>
        )}
      </div>
    </div>
  );
}